<template>
    <div class="child">
        <el-form label-width="90px" ref="formData" :model="formData">
            <!-- 个人信息 -->
            <info :formData="formData" :index="2"></info>
            <!-- 既往病史 -->
            <illness :formData="formData" :index="2"></illness>
            <h5>治疗意见</h5>
            <div class="card">
                <el-form-item label="治疗意见">
                    <el-checkbox-group @change="testSX" v-model="formData.treatmentOpinion">
                        <el-checkbox v-for="(item,index) in needs" :key="index" :label="item.id">
                            <span>{{item.name}}</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="其他" class="double">
                    <el-input v-model.trim="formData.treatmentOpinionOther" style="width:95%;" placeholder="请输入其他治疗意见"></el-input>
                </el-form-item>
            </div>
            <h5>治疗纪录</h5>
            <div class="card">
                <el-form-item label="1.麻醉方式" label-width="140px">
                    <el-radio-group @change="testSX" v-model="formData.anaesthesiaMode">
                        <el-radio :label="1">利多卡因乳膏表麻</el-radio>
                        <el-radio :label="0">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="2.治疗部位" label-width="140px" class="double">
                    <el-input @input="testSX" v-model.trim="formData.treatmentPosition" style="width:95%;" placeholder="请输入治疗部位"></el-input>
                </el-form-item>
                <el-form-item label="3.治疗仪器" label-width="140px" class="double">
                    <el-checkbox-group @change="testSX" v-model="formData.instrumentNo">
                        <el-checkbox v-for="(item,index) in instruments" :key="index" :label="item.id">
                            <span>{{item.name}}</span>
                        </el-checkbox>
                    </el-checkbox-group>
                    <!-- <el-input v-model.trim="formData.instrumentName" disabled style="width:95%;"></el-input> -->
                </el-form-item>
                <el-form-item label="其他" class="double" label-width="140px">
                    <el-input v-model.trim="formData.instrumentOther" style="width:95%;" placeholder="请输入其他诊断"></el-input>
                </el-form-item>
                <el-form-item label="4.治疗参数" class="double" label-width="140px">
                    <el-input v-model.trim="formData.treatmentParameter" style="width:95%;" placeholder="请输入其他诊断"></el-input>
                </el-form-item>
                <el-form-item label="5.治疗后反应" class="double" label-width="140px">
                    <el-form-item label="">
                        <el-checkbox-group @change="testSX" v-model="formData.treatmentReactions">
                            <el-checkbox v-for="(item,index) in lists" :key="index" :label="item.id">
                                <span>{{item.name}}</span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <span>其他</span>
                    <el-input v-model.trim="formData.treatmentReactionsOther" style="width:90%;" placeholder="请输入其他"></el-input>
                </el-form-item>
                <el-form-item label="6.治疗后处理" class="double" label-width="140px">
                    <span>①治疗后按需冷敷</span>
                    <span>②治疗区域0-7天避免沾水</span>
                    <span>③注意补水、保湿及防晒治疗部位</span>
                    <span class="little">④其他 <el-input v-model.trim="formData.treatmentOther" placeholder="请输入"></el-input></span>
                    <span>⑤随访</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer partFooter">
            <el-button type="danger" @click="close">取 消</el-button>
            <el-button type="primary" @click="doAddgoods()">确 定</el-button>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import illness from './illness.vue'
import info from './info'
export default {
    props: ['formData'],
    components: {
        illness, info
    },
    computed: {
        ...mapState(['instruments', 'needs', 'lists']),
    },
    data() {
        return {
            name: '',
        }
    },
    methods: {
        testSX() {
            this.$forceUpdate()
        },
        close() {
            this.$emit('close1')
        },
        doAddgoods() {
            console.log(this.formData);
            let querys = {
                musInformationId: this.formData.id,
                earId: this.formData.earId,
                earName: this.formData.earName,
                treatmentTime: this.formData.sknDate,
                patientName: this.formData.patientName,
                sex: this.formData.sex,
                age: this.formData.age,
                caseCode: this.formData.caseCode,
                doctorName: this.formData.doctorName,
                doctorNo: this.formData.doctorNo,
                chiefComplaint: this.formData.laser.chiefComplaint,
                latestMedicalHistory: this.formData.laser.latestMedicalHistory,
                skinDisease: this.formData.skinDisease,
                diabetes: this.formData.diabetes,
                autoimmuneDisease: this.formData.autoimmuneDisease,
                allergyHistory: this.formData.allergyHistory,
                preparationPregnant: this.formData.preparationPregnant,
                physicalExamination: this.formData.laser.physicalExamination,
                diagnosisOther: this.formData.laser.diagnosisOther,
                anaesthesiaMode: this.formData.anaesthesiaMode,
                treatmentPosition: this.formData.treatmentPosition,
                instrumentOther: this.formData.instrumentOther,
                treatmentParameter: this.formData.treatmentParameter,
                treatmentOther: this.formData.treatmentOther,
                diagnosisNo: this.formData.diagnosisNo.toString(),
                instrumentNo: this.formData.instrumentNo.toString(),
                coagulationDisorders: this.formData.coagulationDisorders,
                medicalHistoryOther: this.formData.medicalHistoryOther,
                createBy: Lockr.get('skinEmpId'),
                treatmentOpinion: this.formData.treatmentOpinion.toString(),
                treatmentReactions: this.formData.treatmentReactions.toString(),
                treatmentReactionsOther: this.formData.treatmentReactionsOther,
                treatmentOpinionOther: this.formData.treatmentOpinionOther,
                cadCode: this.formData.cadCode,
                musProjectId: this.formData.musProjectId,
                musProjectName: this.formData.musProjectName,
                sknFloor: this.formData.sknFloor,
            }
            api.requestQuiet("/skn/createSknCaseLaser", querys, (res) => {
                if (res.result == true) {
                    this.$emit('close1')
                    _g.toast("success", '添加成功');
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { });

        },
    }
}
</script>
<style scoped>
.card >>> .el-select .el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
}
.little >>> .el-input {
  width: 170px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.double >>> .el-input__inner {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.card >>> .el-form-item__label {
  line-height: 30px;
}
.card >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.child >>> .el-form-item {
  margin-bottom: 3px !important;
}
.card >>> .el-input__icon {
  line-height: 30px;
}
.card >>> .el-button i {
  margin: 0 !important;
}
.card >>> .el-button--mini {
  margin-top: 5px;
}
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}
</style>


